import * as React from "react";
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {red, green, grey} from '@mui/material/colors';
import PortalUser from '~common/lib/portal-user-context';
import {CircularProgress} from '@mui/material';
import Dropzone from '~common/components/versioned-document-dropzone';
import {Tooltip} from '@mui/material';
import {IconButton, Icon, Button, Menu, ListSubheader, MenuItem, ListItemIcon, ListItemText} from '@mui/material';
import {ICGFormControl} from '~common/components/icg-form-control';
import * as request from 'superagent';
import PortalUserContext, {UserType} from '~common/lib/portal-user-context';
import * as moment from 'moment';
import {cloneDeep} from 'lodash'
import {ValueContext} from '~common/components/form-def-field-fc';
import {ItemContext} from '~common/components/fields/versioned-document-list-item-fc';


var MAX_FILE_SIZE = 5242880;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
      document: {
        display: 'flex'
      },
      defaultDocument: {
        color: '#2e2eb8'
      },
      deleteButton: {
        padding: 12
      },
      noDocument: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        fontWeight: 500,
        color: '#ccc',
        marginLeft: 15,
        marginTop: 7
      },
      documentIcon: {
        padding: 5,
        cursor: 'pointer'
      },
      documentFileName: {
        padding: 5,
        paddingRight: 10,
        marginTop: 5,
        cursor: 'pointer'
      },
      dropzone: {
        border: '0px dashed #ccc',
        paddingTop: 8,
        marginLeft: 10,
        marginTop: 0,
        width: '2rem',
        height: '2rem',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        cursor: 'pointer'
      },
      loading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 44,
        minHeight: 44
      },
      listArea: {
        display: 'flex',
        alignContent: 'flex-start',
        alignItems: 'center'
      },
      subheader: {
        userSelect: 'none',
        lineHeight: 2.5,
        '&:focus': {
          outlineWidth: 0
        },
        backgroundColor: '#fff'
      },
      docusignSuccess: {
        color: green[600]
      },
      docusignFail: {
        color: red[600]
      },
      docusignUnk: {
        color: grey[600]
      }
  })
);

interface VersionedDocumentFieldProps {
    fieldDefinition: any;
    policyMessages?: any;
    readOnlyOverride?: boolean;
	contextType?: string;
	onItemDelete?: ()=>{};
}

export const VersionedDocumentField: React.FC<VersionedDocumentFieldProps> = ({
    fieldDefinition,
    policyMessages,
    readOnlyOverride,
	contextType,
	onItemDelete,
  }) => {
    const classes = useStyles();   

    var parentContext = ValueContext
    if (contextType == "listItem") {
        parentContext = ItemContext
    }

    const [fieldValue, setFieldValue] = useContext(parentContext); 
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(undefined);
    const [historyAnchorEl, setHistoryAnchorEl] = useState(null);

    let readOnly: boolean = (fieldDefinition.mode == "Read Only" || fieldDefinition.mode == "Display") ? true : false
    if (readOnlyOverride) {
      readOnly = true
    }

    const onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {
        if (rejectedFiles && rejectedFiles.length > 0) {
			
            setUploading(false)
            var errorSet = false
            rejectedFiles.forEach((f: any) => {
                if (f.file.size > (fieldDefinition.maxSize || MAX_FILE_SIZE)) {
                    setError(`File size cannot exceed ${( (fieldDefinition.maxSize || MAX_FILE_SIZE) /(1024 * 1024)).toFixed(0)}MB`)
                    errorSet = true
                    return;
                }
            });
            if (!errorSet){
              setError("Invalid file type")
            }

        } else {
            if (acceptedFiles && acceptedFiles.length > 0) {

                setError(undefined)  
                setUploading(true)
        
                let vd = cloneDeep(fieldValue);

                if (!vd) {
                    vd = {
                        active: {},
                        priorVersions: []
                    };
                }
                  // OK, we have one or more accepted files
                let parseFlag = '';
                if (fieldDefinition.parse) {
                    parseFlag = 'parse=true';
                }

                var opts = '';
                if (fieldDefinition.versionedDocumentOpts){
                  opts = 'opts=' + JSON.stringify(fieldDefinition.versionedDocumentOpts)
                }
                
                var postURL = `/api/attachment-storage`
                if (parseFlag != "" || opts != "") {
                  postURL += "?" + parseFlag + (parseFlag != "" ? "&" + opts : opts)

                }
                for (let f of acceptedFiles) {
                    request
                      .post(postURL)
                      .attach(f.name, f)
                      .then((response) => {
                        if (response.ok) {
                            const att = {
                                fileName: f.name,
                                contentType: f.type,
                                size: f.size,
                                pageCount: response.body.pageCount,
                                storageKey: response.body.storageKey,
                                data: response.body.data,
                                uploadedOn: new Date(),
                                uploadedBy: {
                                    name: PortalUserContext.userContext.displayName,
                                    email: PortalUserContext.userContext.email
                                },
                                retainAsPriorVersion: true
                            };
            
                            if (vd.active && Object.keys(vd.active).length > 0) {
                                if (!vd.priorVersions) {
                                    vd.priorVersions = [];
                                }
                                if (vd.active && vd.active.retainAsPriorVersion != false) {
                                    vd.priorVersions.push(vd.active);
                                }
                            }
                            vd.active = att;
                            setUploading(false)
							              setFieldValue(vd);
                        } else {
                            setError('An error occurred uploading the document')  
                            setUploading(false)
                        }
                      })
                      .catch((err) => {
                        setError('An error occurred uploading the document')  
                        setUploading(false)                     
                      });
                  }
                
              }
        }
    }

    const onDelete = () => {    
		
		if (onItemDelete) {
			onItemDelete()
		} else {
			let vd = cloneDeep(fieldValue)
        
			if (!vd) {
				vd = {
					active: {},
					priorVersions: []
				};
			}

			if (!vd.priorVersions) {
				vd.priorVersions = [];
			}

			if (vd.active && vd.active.retainAsPriorVersion != false) {
				vd.priorVersions.push(vd.active);
			}

			vd.active = null;

			setFieldValue(vd)
		}
    }

    const onClick = (fileName: string, storageKey: string, newWindow?: boolean) => (evt: any) => {
        if (newWindow) {
            window.open(
              '/api/attachment-storage/' + storageKey + '/raw?fileName=' + fileName,
              '_blank'
            );
          } else {
            window.location.href =
              '/api/attachment-storage/' + storageKey + '/raw?fileName=' + fileName;
          }
    };

    const onClickDocumentPath = (documentPath: string, newWindow?: boolean) => (evt: any) => {
        if (newWindow) {
            window.open(documentPath, '_blank');
          } else {
            window.location.href = documentPath;
          }
    };

    const handleShowHistory = (event: any) => {
        setHistoryAnchorEl(event.target)
    };

    const handleHistoryClose = () => {
        setHistoryAnchorEl(undefined)
    };

    const getFileInfo = (mimeType: string, classes: any): {iconClass: string; newWindow: boolean} => {
        var iconClass: any;
        var newWindow: boolean;
    
        switch (mimeType) {
          case 'image/gif':
          case 'image/jpeg':
          case 'image/tiff':
          case 'image/png':
            iconClass = 'fa-file-image ' + classes.icon;
            newWindow = true;
            break;
          case 'application/pdf':
            iconClass = 'fa-file-pdf ' + classes.icon;
            newWindow = true;
    
            break;
          case 'application/msword':
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            iconClass = 'fa-file-word ' + classes.icon;
            newWindow = true;
            break;
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          case 'application/vnd.ms-excel':
            iconClass = 'fa-file-excel ' + classes.icon;
            newWindow = true;
            break;
          case 'text/plain':
            iconClass = 'fa-file-alt ' + classes.icon;
            newWindow = true;
            break;
    
          default:
            iconClass = 'fa-file ' + classes.icon;
            newWindow = true;
            break;
        }
    
        return {iconClass, newWindow};
    };

    const docusignStatusIconClass = (status: string): any => {
        var iconClass: any;
        switch (status) {
          case 'Completed':
            iconClass = classes.docusignSuccess;
            break;
          case 'Voided':
          case 'Declined':
            iconClass = classes.docusignFail;
            break;
          default:
            iconClass = classes.docusignUnk;
        }
        return iconClass;
    };
   

    
    var suppressVersions: boolean = true;
    if (PortalUser.hasOneOfFeatures(['view_prior_versions']) || PortalUserContext.isUserOfType(UserType.PortalAdmin)) {
      suppressVersions = false;
    }

    let attachment: any = null;
    let priorVersions: any = Array<any>();

    let usingDefault = false;
    if (fieldValue) {
        attachment = fieldValue.active;
        priorVersions = fieldValue.priorVersions || []
        if (!attachment || (!attachment.storageKey && !attachment.externalRefs)) {
            if (fieldValue.default) {
              attachment = fieldValue.default;
              usingDefault = true;
            }
        }
    }
    
    let documentView = (
        <div className={classes.noDocument}>
          {'No document uploaded'}
        </div>
    );

    let clickFn: any = null;
    let fileName: any = null;

    let iconClass: any = null;
    let newWindow: any = null;

    let titleClass = '';
    if (usingDefault) {
      titleClass = classes.defaultDocument;
    }


    let docusignInformation: any = null;
    if (attachment) {

        docusignInformation = attachment.docuSignEnvelopeInformation;
  
        var all = getFileInfo(attachment.contentType, classes);
        iconClass = all.iconClass;
        newWindow = all.newWindow;
  
        if (attachment.storageKey) {
          fileName = attachment.fileName;
  
          clickFn = onClick(
            attachment.fileName,
            attachment.storageKey,
            newWindow
          );
        } else if (attachment.documentPath) {
          var pathParts = attachment.documentPath.split('/');
          fileName = pathParts[pathParts.length - 1];
  
          clickFn = onClickDocumentPath(attachment.documentPath, newWindow);
        }
        if (
          !attachment.storageKey &&
          !attachment.documentPath
        ) {
          if (attachment.externalRefs && attachment.externalRefs.length > 0) {
            if (attachment.externalRefs[0].url) {
              fileName = attachment.fileName;
              clickFn = onClickDocumentPath(attachment.externalRefs[0].url, newWindow);
            }
          } else {
            if (fieldDefinition.defaultDocumentURL) {
              var pathParts = fieldDefinition.defaultDocumentURL.split('/');
              fileName = pathParts[pathParts.length - 1];
              var all = getFileInfo('unknown', classes);
              iconClass = all.iconClass;
              newWindow = all.newWindow;
      
              clickFn = onClickDocumentPath(fieldDefinition.defaultDocumentURL, newWindow);
            }
          }
        }
    }

    if (clickFn) {
        documentView = (
          <div className={classes.document}>
            <Button
              size="large"
              className={classes.documentFileName + ' ' + titleClass}
              onClick={clickFn}>
              <i
                className={'far ' + iconClass + ' ' + classes.documentIcon}
                onClick={clickFn}
              />
              {fileName}
            </Button>
            {!usingDefault && !readOnly && (
              <IconButton
                size="large"
                className={classes.deleteButton}
                aria-label="delete"
                onClick={onDelete}>
                <Icon>delete</Icon>
              </IconButton>
            )}
          </div>
        );
    }

    var docusignView: any = null;

    if (docusignInformation) {
        var docusignStatus: string = "Sent"; 
        if (docusignInformation.envelopeStatus && docusignInformation.envelopeStatus.status) {
          docusignStatus = docusignInformation.envelopeStatus.status
        }
        iconClass = docusignStatusIconClass(docusignStatus);
  
        var recipientStatuses = Array<any>();
  
        if (
          docusignInformation.envelopeStatus &&
          docusignInformation.envelopeStatus.recipientStatuses &&
          docusignInformation.envelopeStatus.recipientStatuses.Statuses
        ) {
          recipientStatuses =
            docusignInformation.envelopeStatus.recipientStatuses.Statuses;
        }
  
        docusignView = (
          <div>
            <Tooltip key="docusign" title="Show E-sign Information">
              <IconButton onClick={handleShowHistory} size="large">
                <Icon className={iconClass + ' docusign-history'}>
                  border_color
                </Icon>
              </IconButton>
            </Tooltip>
            <Menu
              id="history-menu"
              anchorEl={historyAnchorEl}
              open={Boolean(historyAnchorEl)}
              onClose={handleHistoryClose}>
              <ListSubheader color="primary" className={iconClass}>
                {docusignStatus}
              </ListSubheader>
              {recipientStatuses && recipientStatuses
                .reduce((acc: Array<any>, pv: any, idx: number) => {
                  var v: any = pv;
                  if (!v) {
                    return acc;
                  }
                  if (Object.keys(v).length == 0) {
                    return acc;
                  }
  
                  var actionDt: string = 'mm/dd/yyyy';
                  var primary: any = null;
                  var secondary: any = null;
                  var status = (v.status || '').toLowerCase();
  
                  switch (status) {
                    case 'completed':
                      secondary =
                        'Completed at ' +
                        moment(v.signed).format('MM/DD/YYYY hh:mm:ss a') +
                        ' by ' +
                        v.userName;
                      break;
                    case 'created':
                      secondary = 'Pending delivery to ' + v.userName;
                      break;
                    case 'sent':
                      secondary =
                        'Sent at ' +
                        moment(v.sent).format('MM/DD/YYYY hh:mm:ss a') +
                        ' by ' +
                        v.userName;
                      break;
                    case 'delivered':
                      secondary =
                        'Delivered at ' +
                        moment(v.delivered).format('MM/DD/YYYY hh:mm:ss a') +
                        ' by ' +
                        v.userName;
                      break;
                    case 'signed':
                      secondary =
                        'Signed at ' +
                        moment(v.signed).format('MM/DD/YYYY hh:mm:ss a') +
                        ' by ' +
                        v.userName;
                      break;
                    case 'declined':
                      secondary =
                        'Declined at ' +
                        moment(v.declined).format('MM/DD/YYYY hh:mm:ss a') +
                        ' by ' +
                        v.userName;
                      break;
                    default:
                      secondary =
                        'Unknown status (' +
                        v.status +
                        ') for recipient' +
                        v.userName;
                  }
  
                  var iconClass = docusignStatusIconClass(v.status);
  
                  acc.push(
                    <MenuItem
                      key={idx}
                      onClick={onClick(v.fileName, v.storageKey, newWindow)}>
                      <ListItemIcon className={classes.icon}>
                        <Icon className={iconClass + ' docusign-recipient-icon'}>
                          border_color
                        </Icon>
                      </ListItemIcon>
                      <ListItemText
                        className={classes.text + ' docusign-recipient'}
                        inset
                        primary={v.email}
                        secondary={secondary}
                      />
                    </MenuItem>
                  );
  
                  return acc;
                }, [])
                .reverse()}
            </Menu>
          </div>
        );
    }

    var priorVersionsView: any = null;
    if (!suppressVersions) {
      priorVersionsView = (
        <div>
          <Tooltip key="history" title="Show prior versions">
            <IconButton onClick={handleShowHistory} size="large">
              <Icon>history</Icon>
            </IconButton>
          </Tooltip>
          <Menu
            id="history-menu"
            anchorEl={historyAnchorEl}
            open={Boolean(historyAnchorEl)}
            onClose={handleHistoryClose}>
            <ListSubheader color="primary" className={classes.subheader}>
              Prior Document Versions
            </ListSubheader>
            {priorVersions
              .reduce((acc: Array<any>, pv: any, idx: number) => {
                var v: any = pv;
                if (!v) {
                  return acc;
                }
                if (Object.keys(v).length == 0) {
                  return acc;
                }
                var {iconClass, newWindow} = getFileInfo(
                  v.contentType,
                  classes
                );
                var uploadedAt = moment(v.uploadedOn).format(
                  'MM/DD/YYYY hh:mm:ss a'
                );
                var secondary: any = null;
                if (v.uploadedBy && v.uploadedBy.name) {
                  secondary =
                    'Uploaded ' + uploadedAt + ' by ' + v.uploadedBy.name;
                }
                acc.push(
                  <MenuItem
                    key={idx}
                    onClick={onClick(v.fileName, v.storageKey, newWindow)}>
                    <ListItemIcon className={classes.icon}>
                      <i
                        className={
                          'far ' + iconClass + ' ' + classes.documentIcon
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      className={classes.text}
                      inset
                      primary={v.fileName}
                      secondary={secondary}
                    />
                  </MenuItem>
                );

                return acc;
              }, [])
              .reverse()}
          </Menu>
        </div>
      );
    }

    let dropZone: any = null;
    if (uploading) {
        dropZone = (
            <div className={classes.loading}>
              <CircularProgress color={'inherit'} size={20} thickness={3} />
            </div>
        );
    } else {
        dropZone = (
            <Dropzone
              multiple={false}
              minSize={fieldDefinition.minSize}
              maxSize={fieldDefinition.maxSize || MAX_FILE_SIZE}
              accept={fieldDefinition.accept || fieldDefinition.acceptedDocumentTypes}
              disabled={readOnly}
              onDrop={onDrop}>
                <div className={classes.dropzone}>
                      <Tooltip key="Upload" title="Upload New Document">
                          <IconButton name={contextType == "listItem" ? "uploadNewVersion" : "uploadNewDocument"} size="large">
                              <Icon>backup</Icon>
                          </IconButton>
                      </Tooltip>
                </div>
            </Dropzone>
          );
    }
    return (
        <ICGFormControl 
            fieldDefinition={fieldDefinition} 
            policyMessages={policyMessages} 
            readOnlyOverride={readOnlyOverride} 
            fieldControlMessage={error} 
            fieldControlClass={error ? 'error' : undefined}
			suppressLabel={contextType == "listItem" ? true : false}
            > 
            <div name={fieldDefinition.key} className={classes.listArea}>
                {!readOnly && dropZone}
                {   
                    !suppressVersions &&
                    priorVersions.length > 0 &&
                    priorVersionsView
                }
                {docusignView}
                {documentView}
            </div>
        </ICGFormControl>
        );
  };

  export default VersionedDocumentField;